import { AllRows, Columns, ReportData } from '../result.interface';


export function getFileExportEntradaSalida(ctx: any, vrs: number): any {
       
   
   var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config:Columns[] = [];

    var duracion_cell_ch_width = "Duracion".length;
    var zone_name_cell_ch_width = "Nombre de Zona".length;
    var zone_position_cell_ch_width = "Posicion de Zona".length;
    var pc_cell_ch_width = "Punto cercano".length;
    var date_cell_px_width = 100; //en px
    var hour_cell_px_width = 94; //en px

    var nom_inf = "REPORTE DE ENTRADA Y SALIDA";

    var allRows: AllRows[] = [
        {
          cells: [
            { value: nom_inf, ...ctx.headerCellConfig, colSpan: 3 }
          ],
          height: ctx.headerRowsHeight,
        },
        ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
    ];

    var table_width = 1 + (ctx.chkDateHour? 4:2) + 4;
    var vehiculo_width = (ctx.chkDateHour? 4:3);

    ctx.sortedData.forEach((table_data: any) => {
      if(table_data[1].length > 0){
        column_config = [];

        bol_datos_ex = true;

        var nom_vehi = table_data[0][1];




        /* Table Header */

        var rows: AllRows[] = [
          {
            cells: [
              { value: nom_inf, ...ctx.headerCellConfig, colSpan: table_width }
            ],
            height: ctx.headerRowsHeight,
          },
          ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
          {
            cells: [
              { value: "VEHÍCULO", ...ctx.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
              { value: "PERIODO",  ...ctx.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
            ],
            height: ctx.subHeaderHeight
          },
          {
            cells: [
              { value: table_data[0][1], ...ctx.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              { value: ctx.period, ...ctx.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width },
            ],
            height: ctx.subHeaderContentHeight
          },
          ...ctx.generateEmptyRowsForRowSpan(ctx.subHeaderContentRowSpan, ctx.subHeaderContentHeight),
        ];

        /* Table Body */

        var cellsCampos = [];

        //----------- CABECERA ------------
        cellsCampos.push({ value: "Ítem", ...ctx.colHeaderConfig });

        if (ctx.chkDateHour) {
          cellsCampos.push({ value: "Fecha de Entrada", ...ctx.colHeaderConfig });
          cellsCampos.push({ value: "Hora de Entrada", ...ctx.colHeaderConfig });
          cellsCampos.push({ value: "Fecha de Salida", ...ctx.colHeaderConfig });
          cellsCampos.push({ value: "Hora de Salida", ...ctx.colHeaderConfig });
        } else {
          cellsCampos.push({ value: "Fecha de Entrada", ...ctx.colHeaderConfig });
          cellsCampos.push({ value: "Fecha de Salida", ...ctx.colHeaderConfig });
        }

        cellsCampos.push({ value: "Duración", ...ctx.colHeaderConfig });
        cellsCampos.push({ value: "Nombre de Geocerca", ...ctx.colHeaderConfig });
        cellsCampos.push({ value: "Posición de Geocerca", ...ctx.colHeaderConfig });
        cellsCampos.push({ value: "Punto Cercano", ...ctx.colHeaderConfig });

        rows.push({
          cells: cellsCampos,
          height: ctx.colsHeaderHeight
        });

        //----------- CONTENIDO / FILAS ------------
        table_data[1].forEach((item: { latitud: number; longitud: number; nombre_zona: any; fecha: any; fecha_out: any; PC: any; duracion: string; }, index: number) => {

          var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";
          var cellsCuerpo = [];

          duracion_cell_ch_width = Math.max(duracion_cell_ch_width, (item.duracion??'').toString().length);
          zone_name_cell_ch_width = Math.max(zone_name_cell_ch_width, (item.nombre_zona??'').toString().length);
          zone_position_cell_ch_width = Math.max(zone_position_cell_ch_width, (ubicacion??'').toString().length);
          pc_cell_ch_width = Math.max(pc_cell_ch_width, (item.PC??'').toString().length);

          cellsCuerpo.push({ value: index + 1, ...ctx.bodyRowsConfig });

          if (ctx.chkDateHour) {
            cellsCuerpo.push({ value: ctx.isChe(item.fecha), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
            cellsCuerpo.push({ value: ctx.isChs(item.fecha), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
            cellsCuerpo.push({ value: ctx.isChe(item.fecha_out), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
            cellsCuerpo.push({ value: ctx.isChs(item.fecha_out), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
          } else {
            cellsCuerpo.push({ value: ctx.isChe(item.fecha), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
            cellsCuerpo.push({ value: ctx.isChe(item.fecha_out), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
          }
          cellsCuerpo.push({ value: item.duracion, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.nombre_zona, ...ctx.bodyRowsConfig });
          //cellsCuerpo.push({ value: ubicacion, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...ctx.bodyRowsConfig });

          cellsCuerpo.push({ value: item.PC, ...ctx.bodyRowsConfig });

          rows.push({
            cells:cellsCuerpo,
            height: ctx.bodyRowsHeight,
          });
        });

        // //********************************************* excel version 2 *********************************
        if ( vrs == 2 ) {
          rows.splice(0, ctx.headerRowSpan);
          rows.push(...ctx.spaceBetweenTables);
          allRows = allRows.concat(rows);
        }

        // //********************************************* excel version 1 *********************************

        /* Ancho de Columnas */

        if( vrs == 1 ){
          column_config = [
            { width: ctx.w_item },
          ];
          if(ctx.chkDateHour){
            column_config.push(
              { width: date_cell_px_width },
              { width: hour_cell_px_width },
              { width: date_cell_px_width },
              { width: hour_cell_px_width },
            )
          } else {
            column_config.push(
              { width: ctx.w_date_and_hour },
              { width: ctx.w_date_and_hour },
            )
          }
          column_config.push(
            { width: ctx.calculateColWidth(duracion_cell_ch_width) },
            { width: ctx.calculateColWidth(zone_name_cell_ch_width) },
            { width: ctx.calculateColWidth(zone_position_cell_ch_width) },
            { width: ctx.calculateColWidth(pc_cell_ch_width) },
          );

          /* Fin Ancho de Columnas */

          exportFileEx.push({
            freezePane: {
                rowSplit: ctx.headerRowSpan + ctx.subHeaderContentRowSpan + 2
              },
            columns: column_config,
            title: nom_vehi,
            rows: rows
          });

          duracion_cell_ch_width = "Duracion".length;
          zone_name_cell_ch_width = "Nombre de Zona".length;
          zone_position_cell_ch_width = "Posicion de Zona".length;
          pc_cell_ch_width = "Punto cercano".length;

        }

      } // if si hay datos del vehiculo
    });

    //NOTA: width * 1.28 (aprox) = Ancho de columna en excel

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;

      column_config = [
        { width: ctx.w_item },
      ];
      if(ctx.chkDateHour){
        column_config.push(
          { width: date_cell_px_width },
          { width: hour_cell_px_width },
          { width: date_cell_px_width },
          { width: hour_cell_px_width },
        )
      } else {
        column_config.push(
          { width: ctx.w_date_and_hour },
          { width: ctx.w_date_and_hour },
        )
      }
      column_config.push(
        { width: ctx.calculateColWidth(duracion_cell_ch_width) },
        { width: ctx.calculateColWidth(zone_name_cell_ch_width) },
        { width: ctx.calculateColWidth(zone_position_cell_ch_width) },
        { width: ctx.calculateColWidth(pc_cell_ch_width) },
      );

      exportFileEx.push({
        freezePane: {
            rowSplit: ctx.headerRowSpan
          },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });

    }


    console.log("===>exportFileEx getFileExportEntradaSalida", exportFileEx);  
        
    if (bol_datos_ex) {
        return exportFileEx;
    } else {
        return [];
    }

}